import React from "react";

const Border = () => {
  return <div className="borderBottom"></div>;
};

export default Border;
